export const liveScoreReducer = (state = [], action) => {
    switch(action.type) {
        case 'REFRESH_SCORE':
            return [...action.payload];

        default:
            return state;
    } 
};



// WEBPACK FOOTER //
// ./src/reducers/liveScore.js